import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const location = useLocation();

  // Function to scroll to top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Function to scroll to features section
  const scrollToFeatures = () => {
    const element = document.getElementById('features-section');
    if (element) {
      const headerOffset = 80; // Adjust based on header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Handle Features menu click
  const handleFeaturesClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      scrollToFeatures();
    }
  };

  // Function to scroll to case studies section
  const scrollToCaseStudies = () => {
    const element = document.getElementById('case-studies-section');
    if (element) {
      const headerOffset = 80; // Adjust based on header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Handle Case Studies menu click
  const handleCaseStudiesClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      scrollToCaseStudies();
    }
  };

  return (
    <footer className="footer-section-new">
      <div className="container">
        <div className="row top-footer-row">
          {/* FOLLOW US */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0 footer-col">
            <h4 className="footer-heading">FOLLOW US</h4>
            <div className="social-icons-wrapper d-flex gap-2 mt-3">
              <a href="https://www.instagram.com/glammifyai/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/website/icons/Link - Instagram.svg" alt="Instagram" />
              </a>
              <a href="https://www.linkedin.com/company/glammify/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/website/icons/Link - LinkedIn.svg" alt="LinkedIn" />
              </a>
              <a href="https://www.facebook.com/glammifyai" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/website/icons/Link - Facebook.svg" alt="Facebook" />
              </a>
              <a href="https://x.com/glammifyai" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/website/icons/Link - Twitter.svg" alt="X" />
              </a>
              <a href="https://www.youtube.com/@glammifyai" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/website/icons/Link - YouTube.svg" alt="YouTube" />
              </a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0 footer-col">
            <h4 className="footer-heading">QUICK LINKS</h4>
            <div className="row mt-3">
              <div className="col-6">
                <ul className="list-unstyled footer-new-links mb-0">
                  <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
                  <li><Link to="/#features-section" onClick={handleFeaturesClick}>Features</Link></li>
                  <li><Link to="/#case-studies-section" onClick={handleCaseStudiesClick}>Case Study</Link></li>
                  <li><Link to="/contact-us" onClick={scrollToTop}>Contact Us</Link></li>
                </ul>
              </div>
              <div className="col-6">
                <ul className="list-unstyled footer-new-links mb-0">
                  <li><Link to="/pricing" onClick={scrollToTop}>Pricing</Link></li>
                  <li><Link to="/blogs" onClick={scrollToTop}>Blog</Link></li>
                  <li><Link to="/faqs" onClick={scrollToTop}>FAQ</Link></li>
                </ul>
              </div>
            </div>
          </div>

          {/* ACCOUNT */}
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0 footer-col">
            <h4 className="footer-heading">ACCOUNT</h4>
            <div className="d-flex flex-column mt-3 account-links-wrap align-items-start">
              <Link to="/login" onClick={scrollToTop} className="account-text-link mb-3">Login / Sign up</Link>
              <Link to="/contact-us" onClick={scrollToTop} className="btn-explore-contact">Contact for Demo</Link>
            </div>
          </div>

          {/* DOWNLOAD APP */}
          <div className="col-lg-3 col-md-6 mb-0 mb-lg-0 footer-col">
            <h4 className="footer-heading">DOWNLOAD APP</h4>
            <div className="d-flex flex-column gap-3 mt-3">
              <a href="https://apps.apple.com/vu/app/glammify-ai/id6751037508" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/website/icons/app-store.svg" alt="Download on the App Store" className="download-badge" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.glammify.app&hl=en_IN" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/website/icons/google-play.svg" alt="Get it on Google Play" className="download-badge" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom-bar mt-5 pt-3 pb-3 mt-md-4 pt-md-4 pb-md-4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start mb-1 mb-md-0 order-2 order-md-1">
              <p className="copyright-text-new mb-0">© {new Date().getFullYear()} Glammify. All rights reserved.</p>
            </div>
            <div className="col-md-6 text-center text-md-end cp-text order-1 order-md-2">
              <div className="bottom-links d-flex justify-content-center justify-content-md-end gap-4">
                <Link to="/terms-conditions" onClick={scrollToTop}>Terms and Conditions</Link>
                <Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
